<ng-container>
  <div class="multipoint-calculate-margin__section">
    <div *ngIf="!isCampaignDetail" class="multipoint-calculate-margin__header">
      <h2>{{ 'NEW_CONTRACTS.CALCULATE_MARGIN' | i18nextEager }}</h2>
    </div>
    <div class="multipoint-calculate-margin__center">
      <form [formGroup]="enterMarginsForm">
        <div
          class="multipoint-calculate-margin__grid-col--12 multipoint-calculate-margin__gap--50"
          [ngClass]="{'multipoint-calculate-margin__pt-style': !isUserSpanish}"
        >
          <div class="multipoint-calculate-margin__col-span--12">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls['marginTP']" appearance="outline" [ngClass]="{
                'multipoint-calculate-margin__fix-label':
                  enterMarginsForm?.controls['marginTP'].invalid &&
                  !(
                    enterMarginsForm?.controls['marginTP'].touched ||
                    enterMarginsForm?.controls['marginTP'].dirty
                  )
              }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TP' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls['marginTP']" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls['marginTP']" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.€KW_ANY' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls['marginTP'].errors?.required &&
                (enterMarginsForm?.controls['marginTP'].touched ||
                  enterMarginsForm?.controls['marginTP'].dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls['marginTP'].errors?.max &&
                  (enterMarginsForm?.controls['marginTP'].touched ||
                    enterMarginsForm?.controls['marginTP'].dirty)
                ">
                {{ 'NEW_CONTRACTS.MAX_24' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="multipoint-calculate-margin__col-span--12 tabs__tabs tabs_fees">
            <button *ngFor="let fee of tabFees; index as i" class="tabs__button-tab"
              [ngClass]="feeIndex === i ? 'secondary tabs__button--active' : 'terciary'"
              (click)="changeFee(i)"
            >
              {{ fee | uppercase }}
            </button>
          </div>
          <div class="multipoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1')" appearance="outline" [ngClass]="{
              'multipoint-calculate-margin__fix-label':
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').invalid &&
                !(
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').dirty
                )
            }">
              <mat-label *ngIf="isUserSpanish">{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P1' | i18nextEager }}</mat-label>
              <mat-label *ngIf="!isUserSpanish">{{ 'NEW_CONTRACTS.MARGIN_AGENTE' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1')" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1')" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').errors?.required &&
                (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').errors?.max &&
                  (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').touched ||
                    enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP1').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="multipoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2')" appearance="outline" [ngClass]="{
              'multipoint-calculate-margin__fix-label':
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').invalid &&
                !(
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P2' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2')" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2')" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').errors?.required &&
                (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').errors?.max &&
                  (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').touched ||
                    enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP2').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="multipoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3')" appearance="outline" [ngClass]="{
              'multipoint-calculate-margin__fix-label':
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').invalid &&
                !(
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P3' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3')" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3')" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').errors?.required &&
                (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').errors?.max &&
                  (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').touched ||
                    enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP3').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="multipoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4')" appearance="outline" [ngClass]="{
              'multipoint-calculate-margin__fix-label':
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').invalid &&
                !(
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P4' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4')" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4')" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').errors?.required &&
                (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').errors?.max &&
                  (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').touched ||
                    enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP4').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="multipoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5')" appearance="outline" [ngClass]="{
              'multipoint-calculate-margin__fix-label':
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').invalid &&
                !(
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P5' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5')" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5')" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').errors?.required &&
                (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').errors?.max &&
                  (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').touched ||
                    enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP5').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUserSpanish" class="multipoint-calculate-margin__col-span--4">
            <mat-form-field *ngIf="enterMarginsForm?.controls[(tabFees[feeIndex])] && enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6')" appearance="outline" [ngClass]="{
              'multipoint-calculate-margin__fix-label':
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').invalid &&
                !(
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').dirty
                )
            }">
              <mat-label>{{ 'NEW_CONTRACTS.MARGIN_TE' | i18nextEager }} {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P6' | i18nextEager }}</mat-label>
              <input matInput [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6')" numberCustom [regex]="regexTwoDecimal"
                [formControl]="enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6')" />
              <span class="multipoint-calculate-margin__bottom-label">{{ 'NEW_CONTRACTS.MW_HOUR' | i18nextEager }}</span>
              <mat-error *ngIf="
                enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').errors?.required &&
                (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').touched ||
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').dirty)
              ">
                {{ 'NEW_CONTRACTS.REQUIRED' | i18nextEager }}
              </mat-error>
              <mat-error *ngIf="
                  enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').errors?.max &&
                  (enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').touched ||
                    enterMarginsForm?.controls[(tabFees[feeIndex])]?.get('marginTEP6').dirty)
                ">
                {{ (isUserSpanish ? (greaterEqual100 ? 'NEW_CONTRACTS.MAX_24' : 'NEW_CONTRACTS.MAX_50') : 'NEW_CONTRACTS.MAX_25') | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="multipoint-calculate-margin__col-span--6 multipoint-calculate-margin__col-start--7">
            <button
              class="multipoint-calculate-margin__button-query"
              [ngClass]="{'multipoint-calculate-margin__button-query--pt': !isUserSpanish}"
              (click)="calculateMargin()"
              [disabled]="!enterMarginsForm?.valid">
              {{ 'NEW_CONTRACTS.CALCULATE' | i18nextEager }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="showCalculation && enterMarginsForm?.valid">
  <div class="multipoint-calculate-margin__section">
    <div *ngIf="!isCampaignDetail" class="multipoint-calculate-margin__header--result multipoint-calculate-margin__header">
      <h2>{{ 'NEW_CONTRACTS.RESULT_SIMULATION' | i18nextEager }}</h2>
    </div>
    <div *ngIf="!isCampaignDetail" class="tabs__tabs">
      <button *ngFor="let zone of geographicZones; index as i" class="tabs__button-tab"
        [ngClass]="geographicTabIndex === i ? 'secondary tabs__button--active' : 'terciary'"
        (click)="changeGeographicZone(i)"
      >
        {{ zone | uppercase }}
      </button>
    </div>
    <div
      *ngFor="let fee of fees, let j=index"
      class="multipoint-calculate-margin__select-calculate-commission__result multipoint-calculate-margin__result"
    >
      <table>
        <h1>{{ fee }}</h1>
        <tr>
          <th id="price"></th>
          <th *ngIf="periods[j] && periods[j] >= 1" id="p1">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P1' | i18nextEager }}</th>
          <th *ngIf="periods[j] && periods[j] >= 2" id="p2">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P2' | i18nextEager }}</th>
          <th *ngIf="periods[j] && periods[j] >= 3" id="p3">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P3' | i18nextEager }}</th>
          <th *ngIf="periods[j] && periods[j] >= 4" id="p4">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P4' | i18nextEager }}</th>
          <th *ngIf="periods[j] && periods[j] >= 5" id="p5">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P5' | i18nextEager }}</th>
          <th *ngIf="periods[j] && periods[j] >= 6" id="p6">{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.P6' | i18nextEager }}</th>
        </tr>
        <tr *ngIf="resultTP.length > 0 && isUserSpanish">
          <td>
            TP<span class="units">{{ 'COMMONS.EUROS_KW_YEAR' | i18nextEager }}</span>
          </td>
          <td *ngFor="let tp of resultTP[j]?.slice(0, periods[j]); let i = index">
            {{ (fees[j] === '2.0TD' && i >= 3 ? null : (tp ? tp : '')) | number: '1.6-6' }}
          </td>
        </tr>
        <tr *ngIf="resultTE.length > 0 && fixPrice && !passThrough && !fijoFlex">
          <td>
            TE<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let te of resultTE[j]?.slice(0, periods[j]); let i = index">
            {{ (fees[j] === '2.0TD' && i >= 3 ? null : (te ? te : '')) | number: '1.6-6' }}
          </td>
        </tr>
        <tr *ngIf="resultAI.length > 0 && !fixPrice && !passThrough && !fijoFlex">
          <td>
            Ai<span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let ai of resultAI[j]?.slice(0, periods[j]); let i = index">
            {{
            (fees[j] === '2.0TD' && i >= 3 ? null : (ai ? (ai + campaignRealTE[j][i]) : (ai ? ai : '')))
            | number: '1.6-6'
            }}
          </td>
        </tr>
        <tr *ngIf="resultFijoFlexSimple.length > 0 && fijoFlex && !isUserSpanish && fijoFlexSimple">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.PF_REF' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let pref of resultFijoFlexSimple[j]?.slice(0, periods[j]); let i = index">
            {{ fees[j] === '2.0TD' && i >= 3 ? null : ( pref ? pref : '' ) | number: '1.6-6' }}
          </td>
        </tr> 
        <tr *ngIf="(campaignKI.length > 0 && !fixPrice && !passThrough && !fijoFlex) || (campaignKI.length > 0 && fijoFlex && !isUserSpanish && fijoFlexSimple)">
          <td>
            Ki
          </td>
          <td *ngFor="let ki of campaignKI[j]?.slice(0, periods[j]); let i = index">
            {{ (fees[j] === '2.0TD' && i >= 3 ? null : ki) | number: '1.3-6' }}
          </td>
        </tr>
        <tr *ngIf="passThrough && isUserSpanish">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.GDOS' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let gdo of campaignGDOS[j]?.slice(0, periods[j]); let i = index">
            {{ fees[j] === '2.0TD' && i >= 3 ? null : ( gdo ? ((gdo / 1000) | number: '1.6-6') : '') }}
          </td>
        </tr>
        <tr *ngIf="passThrough || (fijoFlex && !isUserSpanish && fijoFlexSimple)">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.CG' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let cg of resultCG[j]?.slice(0, periods[j]); let i = index">
            {{ fees[j] === '2.0TD' && i >= 3 ? null : (cg ? (( cg / 1000) | number: '1.6-6') : '') }}
          </td>
        </tr>
        <tr *ngIf="passThrough && isUserSpanish">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FI' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let fi of campaignFI[j]?.slice(0, periods[j]); let i = index">
            {{ fees[j] === '2.0TD' && i >= 3 ? null : (fi ? ((fi / 1000) | number: '1.6-6') : '') }}
          </td>
        </tr>
        <tr *ngIf="resultFijoFlex.length > 0 && fijoFlex && !fijoFlexSimple">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.FIXED_PRICE' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let pfijo of resultFijoFlex[j]?.slice(0, periods[j]); let i = index">
            {{ (fees[j] === '2.0TD' && i >= 3 ? null : (pfijo ? pfijo : '')) | number: '1.6-6' }}
          </td>
        </tr>
        <tr *ngIf="fijoFlex && isUserSpanish">
          <td>
            <span>{{ 'CAMPAIGNS.CAMPAIGN-DETAIL.S_ADJUST' | i18nextEager }}</span>
            <span class="units">{{ 'COMMONS.EUROS_KWH' | i18nextEager }}</span>
          </td>
          <td *ngFor="let pfijo of campaignPFijo[j]?.slice(0, periods[j]); let i = index">
            {{ 'CAMPAIGNS.CAMPAIGN-DETAIL.INDEX' | i18nextEager }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</ng-container>
